import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3425111a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-column w-100 h-100 bg-sady" }
const _hoisted_2 = ["onload", "src"]
const _hoisted_3 = { class: "action-button-panel d-flex justify-content-center align-items-center w-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x",
  style: {"font-size":"2.75rem"}
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-check2",
  style: {"font-size":"2.25rem"}
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import {ref} from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  files: {
    type: Object,
    required: true,
    default() {
      return null
    }
  }
},
  emits: ["userDiscarded", "userConfirmed"],
  setup(__props, { emit }: { emit: ({
  (e: 'userDiscarded'): void
  (e: 'userConfirmed'):void
}), expose: any, slots: any, attrs: any }) {

const props = __props





let files = props.files as FileList

const previews = Array.from(files).map((i: File) => ({
  ref: ref(null),
  src: URL.createObjectURL(i)
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(previews), (preview, i) => {
      return (_openBlock(), _createElementBlock("img", {
        key: i,
        ref: preview.ref,
        onload: () => _ctx.URL.revokeObjectURL(preview.src),
        src: preview.src,
        alt: "Image Preview",
        class: "preview-image"
      }, null, 8, _hoisted_2))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        type: "button",
        class: "round button-warn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('userDiscarded')))
      }, _hoisted_5),
      _createElementVNode("button", {
        type: "button",
        class: "round button-primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('userConfirmed'))),
        style: {"margin-left":"2.5rem"}
      }, _hoisted_7)
    ])
  ]))
}
}

})